// extracted by mini-css-extract-plugin
export default {"quantity-button":"quantity-button_quantity-button__Rw2W8","quantity-button--clicked":"quantity-button_quantity-button--clicked__7Cx6W"};